<template>
  <div class="subscription-button-container">
    <FriedParagraph
      v-if="!compact"
      :size="ParagraphSize.Small"
      class="trial-description truncate one-line"
      :class="[{ expanded: !compact }]"
    >
      {{ t('trial_plan_days_left') }}
      <span class="trial-days">{{ daysLeft }}</span>
    </FriedParagraph>
    <button
      v-wave
      v-tooltip="{
        content: $t('trial_tooltip_info_button'),
        distance: 12,
        placement: Placement.Right,
        delay: { show: 300, hide: 100 },
      }"
      :class="['subscription-info-button']"
      data-external="global-sidebar-:subscription-info-button"
      @click="$emit('click')"
    >
      <FriedIcon icon="publish" class="icon" />
      <FriedH4 v-if="!compact" class="label truncate">
        {{ t('trial_plan_get_more_info_button') }}
      </FriedH4>
    </button>
    <hr class="divider" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ParagraphSize, Placement } from '@getaccept/fried-tofu';
import { storeToRefs } from 'pinia';

import { useSubscriptionStore } from '../store/subscription.store';

export default defineComponent({
  props: {
    compact: { type: Boolean },
  },
  emits: ['click'],
  setup() {
    const { daysLeft } = storeToRefs(useSubscriptionStore());

    return {
      t,
      ParagraphSize,
      daysLeft,
      Placement,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@getaccept/lib-shared/src/assets/scss/truncate-text';

.subscription-button-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .trial-description {
    display: flex;
    opacity: 0;
    height: 0;
    white-space: pre;
    padding-bottom: var(--spacing-100);
    transition: all 1s ease-in-out;

    &.expanded {
      opacity: 1;
      height: 2rem;
      animation: fade-in 0.3s ease-in-out;
    }
  }

  .trial-days {
    font-weight: 600;
  }

  .subscription-info-button {
    position: relative;
    width: 100%;
    text-decoration: none;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-100);
    padding: 0 var(--spacing-50);
    border-radius: 0.375rem;
    height: calc(var(--spacing-200) + var(--spacing-50));
    min-width: 3.375rem;
    background-color: var(--lilac-93);
    color: var(--lilac-55);
    transition: background-color 0.1s ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: var(--lilac-97);
    }

    &.old-sidebar {
      width: 50%;
    }

    .icon {
      height: var(--spacing-150);
      width: var(--spacing-150);
    }

    .label {
      cursor: pointer;
      color: var(--lilac-55);
    }
  }

  .divider {
    display: flex;
    width: 100%;
    margin: var(--spacing-150) 0;
  }
}

@keyframes fade-in {
  0% {
    height: 0;
    opacity: 0;
  }

  1% {
    height: var(--spacing-200);
  }

  100% {
    opacity: 1;
  }
}
</style>
